// Universal recording indicator (F-REC-1, §10.5). A persistent, non-dismissable
// red badge shown to EVERYONE while any participant is recording — a trust
// invariant (§16). Driven purely by the store's recordingBy, which the engine
// sets from the rec:on/off broadcast + heartbeat-loss clearing.

import { probeRender } from '../perf/renderProbe';
import { useCallStore } from '../store/callStore';

export function RecordingIndicator() {
  probeRender('RecordingIndicator');
  const by = useCallStore((s) => s.recordingBy);
  if (!by) return null;
  return (
    <div className="bz-pill bz-recording-indicator" role="status" aria-live="polite">
      <span className="bz-rec-dot" aria-hidden="true" />
      <span>REC · {by}</span>
    </div>
  );
}
